import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-semantic-high',
  templateUrl: './semantic-high.component.html',
  styleUrl: './semantic-high.component.css',
})
export class SemanticHighComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: string;
  }>();

  selectedValue: string | null = null;

  handleSelection(value: string): void {
    this.selectedValue = value;
    this.answerSelected.emit({
      questionUuid: this.question.uuid,
      answerValue: value,
    });
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
